import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const oracleJdEdwards = defineConnector({
  identifier: "oracleJdEdwards",
  name: "Oracle JD Edwards",
  tagLine: "Enterprise resource planning",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: ({ serverUrl }) => exactUrlToRegex(serverUrl),
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Get your JD Edwards API credentials",
      items: [
        {
          kind: "markdown",
          content: `1. Sign in to your JD Edwards EnterpriseOne server manager
2. Navigate to **AIS Server Configuration**
3. Ensure the REST API is enabled
4. Obtain your username and password with the required roles`,
        },
      ],
    },
    {
      title: "Enter your JD Edwards details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://jde.yourcompany.com:9090",
          target: { kind: "configuration", field: "serverUrl" },
          helperText: "Your JD Edwards AIS server URL.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "secrets", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) => `${serverUrl}/jderest/v2/tokenrequest`,
  },
  publicEnvVars: ({ serverUrl }) => ({
    ORACLE_JD_EDWARDS_URL: serverUrl || "",
  }),
});
